import Submisson from "scenes/submitter/submission";
import Revision from "scenes/submitter/revision";
import Submitter from "scenes/submitter";
import RoleEnum from "constants/roleEnum";
import RouteEnum from "constants/routesEnum";
import ArticleReviewTracker from "scenes/common/aritcle-review-tracker";

const SubmitterRoutes = [
  {
    exact: true,
    component: Submitter,
    role: RoleEnum.Submitter,
    title: "Dashboard",
    path: RouteEnum.submitter,
  },
  {
    exact: true,
    component: Submisson,
    role: RoleEnum.Submitter,
    title: "Submission",
    path: RouteEnum.submission,
  },
  {
    exact: true,
    component: Submisson,
    role: RoleEnum.Submitter,
    title: "Submission",
    path: `${RouteEnum.submission}/:articleId`,
  },
  {
    exact: true,
    component: Submisson,
    role: RoleEnum.Submitter,
    title: "Revision",
    path: `${RouteEnum.revision}/:revisionId/:articleId`,
  },
  {
    exact: true,
    component: Revision,
    role: RoleEnum.Submitter,
    title: "Submission",
    path: `${RouteEnum.revisionDetail}/:revisionId`,
  },
  {
    exact: true,
    component: ArticleReviewTracker,
    roles: [RoleEnum.Submitter, RoleEnum.Administrator, RoleEnum.Editor],
    title: "Review Tracker",
    path: `${RouteEnum.articleReviewTracker}/:articleId`,
  },
];

export default SubmitterRoutes;
